import {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import addBoardPermissionsImg from "../../content/img/add-boardpermissions.svg";
import { useTranslation } from "react-i18next";
import { Tab } from "@etframework/ui.components";
import { SelectUsersDropdown } from "./SelectUsersDropdown";
import { BoardPermissionsGrid } from "./BoardPermissionsGrid";
import { removObjects } from "../../utils/helpers";
import { useDueDatesAuth } from "../../hooks/useDueDatesAuth";
import Enums from "../../types/enums";

export const AddBoardPermissionsForm = forwardRef(
  ({ boardName, users, initState, id }, ref) => {
    const { t } = useTranslation(["CreateBoardModal", "Shared"]);
    const { UserId, UserFullName } = useDueDatesAuth();

    //References
    const selectUsersRef = useRef(null);

    //State
    const [selectedValues, setSelectedValues] = useState([...initState]);

    const _users = useMemo(() => {
      return (
        users
          ?.filter((x) => x.Id != UserId)
          .map((user) => ({
            Id: user.Id,
            PermissionType: Enums.PermissionType.User,
            Name: user.FullName ?? user.Email,
          })) ?? []
      );
    }, [users]);

    // Dropdown Handlers (on click 'add to list button')
    const addUser = (usersToAdd) =>
      setSelectedValues((prev) => [...prev, ...usersToAdd]);

    //Grid handlers
    const onRemoveItemFromGrid = (itemsToRemove) =>
      setSelectedValues((prev) => removObjects(prev, itemsToRemove));

    useImperativeHandle(
      ref,
      () => ({
        getValue: () => selectedValues,
      }),
      [selectedValues]
    );

    return (
      <div id={id} className="create-board-modal-content add-users-form">
        <div className="picture-container">
          <img src={addBoardPermissionsImg} height={145} />
          <p className="picture-message">
            {t("AddUserPicture", { board: boardName })}
          </p>
          <p className="picture-subtitle">{t("AddUserPictureSubtitle")}</p>
        </div>
        <div className="tab-container">
          <div className="mt-4">
            <div className="mb-3">
              <Tab
                tabNames={[t("Tab1")]}
                tabComponents={[
                  <SelectUsersDropdown
                    id={id + "_select-users-tab"}
                    type={"User"}
                    ref={selectUsersRef}
                    key={"users-tab"}
                    click={addUser}
                    usersDataSource={_users}
                    filter={useCallback(
                      (x) =>
                        x.PermissionType === Enums.PermissionType.User &&
                        !selectedValues.map((y) => y.Id).includes(x.Id),
                      [selectedValues]
                    )}
                  />,
                ]}
                typeOfTab="purchase"
                reorderActiveTab={false}
              />
            </div>
            <div className="grid-conatiner">
              <BoardPermissionsGrid
                dataSource={[
                  {
                    Name: UserFullName,
                    Id: UserId,
                    currentUser: true,
                    Enabled: false,
                  },
                  ...selectedValues,
                ]}
                onRemoveItems={onRemoveItemFromGrid}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
);
